
import { useContext, useState } from "react";
import JobOverlay from './JobOverlay';
import JobOverlayActivities from './JobOverlayActivities';

import { useNavigate } from 'react-router-dom';
import { useFirstname } from "../../hooks/useFirstname";
import { getItem } from "../../api/jobExplorer";
import { ProsContext } from "../../context/ProsContext";
import { AuthContext } from "../../context/AuthContext";
import { isProAccessBlocked } from "../../config/freemium";

export default function JobCard({ job, selected, setSelected, onSend, overlay, onOpenPremiumModal }) {
  const { getRandomFirstname } = useFirstname();
  const navigate = useNavigate();
  const { itemsPro, setItemsPro } = useContext(ProsContext);
  const [ loading, setLoading ] = useState(false);
  const { user } = useContext(AuthContext);

  const displayAction = () => {
    if ( selected !== job.id )
      setSelected(job.id)
    else
      setSelected(null)
  }

  function handleClickDetail() {
    let gender = job.photo_url.includes('_f/') ? 'girl' : 'boy'
    navigate(`/metiers/${job.id}/${gender}`);
  }

  async function handleClickChat(e) {
    e.stopPropagation()
    setLoading(true)
    const job_from_api = await getItem(job.id)
    let gender = job.photo_url.includes('_f/') ? 'girl' : 'boy'

    if (isProAccessBlocked(user, itemsPro, job.id)) {
      const jobTitle = gender === 'boy' ? job_from_api.title_m : job_from_api.title_f
      onOpenPremiumModal(`échanger avec ${jobTitle}`)
      setLoading(false)
      return
    }

    let name
    if ( itemsPro[job.id] ) {
      name = itemsPro[job.id].name
    } else {
      name = gender === 'boy' ? getRandomFirstname('male') : getRandomFirstname('female')
      setItemsPro({
        ciaov2_job_id: job.id,
        name,
        gender,
        title: gender === 'boy' ? job_from_api.title_m : job_from_api.title_f
      })
    }

    const qualities = job_from_api._qualities.map( (quality) => `${quality._quality.label} : ${quality.explanation}` ).join("\n")
    const level_of_education = job_from_api._study_levels.map( (study_level) => study_level._study_level.label ).join(", ")
    const salary = `Salaire début de carrière de ${job_from_api.salary_min}€ pouvant aller jusqu'à ${job_from_api.salary_max}€. ${job_from_api.salary_explanation}`
    const salary_evolution_explanation = job_from_api.salary_evolutions.map( (salary_evolution) => 
      `${salary_evolution.experience} (${salary_evolution.experience_years}) gagne environ ${salary_evolution.experience_salary}. Role : ${salary_evolution.experience_role}.`
    ).join("\n")
    const values = {
      id: job_from_api.id,
      title: gender === 'boy' ? job_from_api.title_m : job_from_api.title_f,
      title_for_prompt: gender == 'boy' ? job_from_api.title_for_prompt_m : job_from_api.title_for_prompt_f,
      name: name,
      picture: job.photo_url,
      qualities: qualities,
      salary: salary,
      salary_evolution_explanation: salary_evolution_explanation,
      level_of_education: level_of_education,
      gender: gender,
      from: "job_card"
    }
    let path = await onSend(values)
    setSelected(null)
    setLoading(false)
    navigate(path);
  }
  
  return (
    <div className="w-full bg-gray-800 flex flex-col rounded-xl relative">
      <div className="w-full bg-gray-800 flex flex-wrap rounded-xl p-4 gap-4 cursor-pointer"
        onClick={displayAction}>
        <img className="w-40 h-auto object-cover" src={job.photo_url} loading="lazy"/>
        <div className="flex-1 gap-2">
          <div className="items-center mb-2">
            {/* Emoji métier */}
            <h3 className="text-lg font-semibold text-white">{job.title}</h3>
          </div>
          <div className="flex flex-wrap gap-2 mb-2">
            <div className="bg-gray-800 rounded-lg flex flex-wrap gap-2 text-xs">
              {job.categories.map((item, index) => (
                <div key={`${item}_${index}`} className="px-2 py-1 rounded text-sm font-medium text-xs bg-teal-400/20 text-teal-500">{item}</div>
              ))}
              {overlay === "filters" && job.qualities.map((item, index) => (
                <div key={`${item}_${index}`} className="px-2 py-1 rounded text-sm font-medium text-xs bg-blue-400/20 text-blue-500">{item}</div>
              ))}
              {overlay === "filters" && job.interests.map((item, index) => (
                <div key={`${item}_${index}`} className="px-2 py-1 rounded text-sm font-medium text-xs bg-purple-400/20 text-purple-500">{item}</div>
              ))}
              {overlay === "filters" && job.study_levels.map((item, index) => (
                <div key={`${item}_${index}`} className="px-2 py-1 rounded text-sm font-medium text-xs bg-orange-400/20 text-orange-500">{item}</div>
              ))}
            </div>
          </div>
          <p className="text-sm text-gray-300 pt-2">{job.description}</p>

          <div className="w-full pt-4">
            <div className="flex flex-1  justify-center gap-1">
              <div className="w-2 h-2 rounded-full transition-all duration-200 bg-gray-600"></div>
              <div className="w-2 h-2 rounded-full transition-all duration-200 bg-gray-600"></div>
              <div className="w-2 h-2 rounded-full transition-all duration-200 bg-gray-600"></div>
            </div>
          </div>
        </div>
        {(overlay === "search" || overlay === "filters") && <JobOverlay loading={loading} isOpen={selected === job.id} onClickChat={handleClickChat} onClickDetail={handleClickDetail} />}
        {overlay === "activities" && <JobOverlayActivities isOpen={selected === job.id} onClickQuizz={handleClickQuizz} onClickGritAndFit={handleClickGritAndFit} />}

      </div>
    </div>
  );
}
